function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.6,106.5H250l-12-30H162l-12,30h-4v-15H128v15h-3.6A14.41,14.41,0,0,0,110,120.9V209a14.52,14.52,0,0,0,14.5,14.5h151A14.52,14.52,0,0,0,290,209V120.9A14.41,14.41,0,0,0,275.6,106.5ZM134,97.5h6v9h-6ZM284,209a8.51,8.51,0,0,1-8.5,8.5h-151A8.51,8.51,0,0,1,116,209V120.9a8.41,8.41,0,0,1,8.4-8.4H154l12-30H234l12,30H275.6a8.41,8.41,0,0,1,8.4,8.4Z",
    style: {
      fill: "#d7d7d7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,103.5a54,54,0,1,0,54,54A54.06,54.06,0,0,0,200,103.5Zm0,102a48,48,0,1,1,48-48A48.06,48.06,0,0,1,200,205.5Z",
    style: {
      fill: "#d7d7d7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,121.5a36,36,0,1,0,36,36A36,36,0,0,0,200,121.5Zm0,66a30,30,0,1,1,30-30A30,30,0,0,1,200,187.5Z",
    style: {
      fill: "#d7d7d7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,118.5a12,12,0,1,0,12,12A12,12,0,0,0,266,118.5Zm0,18a6,6,0,1,1,6-6A6,6,0,0,1,266,136.5Z",
    style: {
      fill: "#d7d7d7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingPhoto);
export default __webpack_public_path__ + "static/media/missing_photo.4c8db18917db6ea0bc142270aadc252c.svg";
export { ForwardRef as ReactComponent };